import { isNativePlatform } from './platform';

export function registerServiceWorker() {
  if (isNativePlatform()) {
    return;
  }

  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register(`${import.meta.env.BASE_URL}sw.js`).catch(() => {
        // Service worker registration can fail due to browser extensions,
        // CSP policies, or network issues — safe to ignore
      });
    });
  }
}
